import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RemindersFormComponent } from './reminders/reminders-form/reminders-form.component';
import { RemindersListComponent } from './reminders/reminders-list/reminders-list.component';
import { RemindersRoutingModule } from '@app/reminders/reminders-routing.module';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@app/shared';
import { RemindersViewComponent } from './reminders/reminders-view/reminders-view.component';
import { UserSelectMultipleComponent } from '@app/shared/components/user-select-multiple/user-select-multiple.component';

@NgModule({
  declarations: [RemindersFormComponent, RemindersListComponent, RemindersViewComponent, UserSelectMultipleComponent],
  imports: [CommonModule, RemindersRoutingModule, ReactiveFormsModule, SharedModule],
})
export class RemindersModule {}
